module.exports = __webpack_public_path__ + "media/images/img_unite-1ef5d879661a8e794425eaaddcf4296d.png";